module.exports = __webpack_public_path__ + "media/components/country-flag/static/ro-10d4578ab5146f6a242b2c5c9f108154.svg";